import {
	Links,
	Meta,
	Outlet,
	Scripts,
	ScrollRestoration,
	useRouteError,
} from "@remix-run/react";
import type { LinksFunction } from "@remix-run/cloudflare";
import type React from "react";

import "./tailwind.css";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";

import { Providers } from "./providers";
import { Navbar } from "components/navbar";
import { PrettyError } from "components/error";

export const links: LinksFunction = () => [
	{ rel: "preconnect", href: "https://fonts.googleapis.com" },
	{
		rel: "preconnect",
		href: "https://fonts.gstatic.com",
		crossOrigin: "anonymous",
	},
	{
		rel: "stylesheet",
		href: "https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap",
	},
	{
		rel: "icon",
		type: "image/png",
		href: "/favicon-96x96.png",
		sizes: "96x96",
	},
	{
		rel: "icon",
		type: "image/svg+xml",
		href: "/favicon.svg",
	},
	{
		rel: "shortcut icon",
		href: "/favicon.ico",
	},
	{
		rel: "apple-touch-icon",
		sizes: "180x180",
		href: "/apple-touch-icon.png",
	},
	{
		rel: "manifest",
		href: "/site.webmanifest",
	},
];

export function Layout({ children }: { children: React.ReactNode }) {
	return (
		<html lang="es">
			<head>
				<meta charSet="utf-8" />
				<meta
					name="apple-mobile-web-app-title"
					content="Minecraft Community Awards"
				/>
				<meta name="theme-color" data-react-helmet="true" content="#000000" />
				<meta content="Minecraft Community Awards" property="og:title" />
				<meta
					content="Un evento impulsado por la comunidad que celebra lo mejor de la creatividad de Minecraft. Son premios que reconocen todo, desde clips graciosos y construcciones épicas hasta series destacadas y contenido innovador de los creadores."
					property="og:description"
				/>
				<meta content="https://mca.eufonia.studio" property="og:url" />
				<meta
					content="https://mca.eufonia.studio/cdn-cgi/image/format=auto/mca.webp"
					property="og:image"
				/>
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<meta
					httpEquiv="Delegate-CH"
					content="sec-ch-dpr https://mca.eufonia.studio; sec-ch-viewport-width https://mca.eufonia.studio"
				/>
				<Meta />
				<Links />
			</head>

			<body className="bg-black">
				<Providers>
					<div className="relative flex flex-col h-screen z-0">
						<Navbar />
						{children}
					</div>
					<ScrollRestoration />
					<Scripts />
				</Providers>
				<script
					defer
					src="https://static.cloudflareinsights.com/beacon.min.js"
					data-cf-beacon='{"token": "13614ec38c8f4745858fd4cc49cdd888"}'
				/>
			</body>
		</html>
	);
}

export default function App() {
	return <Outlet />;
}

export function ErrorBoundary() {
	const error = useRouteError();
	console.error(error);

	return <PrettyError error={error} />;
}
